import React from 'react'
import TypedHeading from '../TypedHeading'
import './styles.ts'
import { Wrapper } from './styles'
import { LoadingOverlay as StyledLoadingOverlay } from './styles'
import { DolaThemes } from '../../styles/types'

interface OrderLoaderProps {
  loading: boolean
  className?: string
  lines: string[]
  theme?: DolaThemes
}

const LoadingOverlay: React.FC<OrderLoaderProps> = ({
  children,
  loading,
  lines,
  theme = 'light',
}) => {
  return (
    <Wrapper>
      {children}
      {loading && (
        <StyledLoadingOverlay className="loading-overlay" dolaTheme={theme}>
          <TypedHeading strings={lines} />
        </StyledLoadingOverlay>
      )}
    </Wrapper>
  )
}

export default LoadingOverlay
